import React from 'react';

// Skeleton loader for DoseTermsExplainer component
export const DoseTermsExplainerSkeleton: React.FC = () => (
  <div className="dose-terms-explainer">
    <div className="dose-terms-header">
      <div className="skeleton-shimmer" style={{ height: '32px', borderRadius: '4px', marginBottom: '8px' }} />
      <div className="skeleton-shimmer" style={{ height: '48px', borderRadius: '4px' }} />
    </div>
    <div className="dose-terms-grid">
      {[1, 2, 3, 4].map(i => (
        <div
          key={i}
          className="dose-term-card"
          style={{ minHeight: '120px', backgroundColor: '#f8f8f8', borderRadius: '8px' }}
        >
          <div style={{ padding: '16px' }}>
            <div className="skeleton-shimmer" style={{ height: '24px', borderRadius: '4px', marginBottom: '8px' }} />
            <div className="skeleton-shimmer" style={{ height: '60px', borderRadius: '4px' }} />
          </div>
        </div>
      ))}
    </div>
  </div>
);

// Skeleton loader for DosageTable component
export const DosageTableSkeleton: React.FC = () => (
  <div style={{ marginTop: '20px' }}>
    <div className="skeleton-shimmer" style={{ height: '48px', borderRadius: '4px', marginBottom: '16px' }} />
    <div
      style={{
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
        overflow: 'hidden',
      }}
    >
      <div className="skeleton-shimmer" style={{ height: '40px' }} />
      {[1, 2, 3, 4, 5, 6].map(i => (
        <div
          key={i}
          className="skeleton-shimmer"
          style={{
            height: '36px',
            borderTop: '1px solid #e0e0e0',
            animationDelay: `${i * 0.1}s`,
          }}
        />
      ))}
    </div>
  </div>
);

// Skeleton loader for OtherCalcs component
export const OtherCalcsSkeleton: React.FC = () => (
  <div id="other-links">
    <div
      className="kofi-section center-flex skeleton-shimmer"
      style={{ height: '60px', borderRadius: '8px', marginBottom: '24px' }}
    />

    <div className="skeleton-shimmer" style={{ height: '32px', borderRadius: '4px', marginBottom: '16px' }} />
    <div className="calculator-grid">
      {[1, 2, 3, 4, 5, 6, 7].map(i => (
        <div
          key={i}
          className="calculator-card"
          style={{
            minHeight: '120px',
            backgroundColor: '#f8f8f8',
            borderRadius: '8px',
            border: '1px solid #e0e0e0',
          }}
        >
          <div style={{ padding: '16px' }}>
            <div
              className="skeleton-shimmer"
              style={{ height: '20px', borderRadius: '4px', marginBottom: '8px', animationDelay: `${i * 0.1}s` }}
            />
            <div
              className="skeleton-shimmer"
              style={{ height: '40px', borderRadius: '4px', animationDelay: `${i * 0.1 + 0.05}s` }}
            />
          </div>
        </div>
      ))}
    </div>

    <div style={{ marginTop: '32px' }}>
      <div className="skeleton-shimmer" style={{ height: '32px', borderRadius: '4px', marginBottom: '16px' }} />
      <div className="guides-grid">
        {[1, 2, 3].map(i => (
          <div
            key={i}
            className="guide-card"
            style={{
              minHeight: '100px',
              backgroundColor: '#f8f8f8',
              borderRadius: '8px',
              border: '1px solid #e0e0e0',
            }}
          >
            <div style={{ padding: '16px' }}>
              <div
                className="skeleton-shimmer"
                style={{ height: '20px', borderRadius: '4px', marginBottom: '8px', animationDelay: `${i * 0.1}s` }}
              />
              <div
                className="skeleton-shimmer"
                style={{ height: '32px', borderRadius: '4px', animationDelay: `${i * 0.1 + 0.05}s` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);
